import {makeEnumRuntimeType} from '../../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {ActionWithPayload} from '../../../../helpers/reduxHelpers';
import {AppAction} from '../../../appActions';
import {ThunkAsyncAction} from '../../../appThunk';
import {fetchActivityAsyncAction, isActivityLoaded} from '../../../data/activities/activitiesActions';
import {getActivities} from '../../../data/dataSelectors';
import {PanelActionPayload} from '../../panelsActions';
import {ViewerPanelId} from '../../panelStateBase';

/*
 * Action types.
 */

export enum ActivityViewerActionsEnum {
  EXPANDED = '@@panels/viewer/activity/EXPANDED',
  COLLAPSED = '@@panels/viewer/activity/COLLAPSED',
}
const RActivityViewerActionType = makeEnumRuntimeType(ActivityViewerActionsEnum);

/*
 * Types.
 */

interface ActivityViewerActionPayload extends PanelActionPayload<ViewerPanelId> {
  activityId: number;
}

export interface ActivityViewerExpandedAction extends ActionWithPayload<ActivityViewerActionPayload> {
  type: ActivityViewerActionsEnum.EXPANDED;
}

export interface ActivityViewerCollapsedAction extends ActionWithPayload<ActivityViewerActionPayload> {
  type: ActivityViewerActionsEnum.COLLAPSED;
}

/*
 * Type guard.
 */

export function isActivityViewerAction(action: AppAction): action is ActivityViewerActions {
  return RActivityViewerActionType.is(action.type);
}

/*
 * Action creators.
 */

export function expandActivityViewerAsyncAction(
  panelId: ViewerPanelId,
  activityId: number,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const state = getState();

    // Find the activity.
    const activity = getActivities(state)[activityId];
    if (!activity) {
      return;
    }

    // Load the activity, if necessary.
    if (!isActivityLoaded(state, activity)) {
      await dispatch(fetchActivityAsyncAction(activity.conversationId, activityId));
    }

    dispatch<ActivityViewerExpandedAction>({
      type: ActivityViewerActionsEnum.EXPANDED,
      payload: {
        panelId,
        activityId,
      },
    });
  };
}

export function collapseActivityViewerAction(
  panelId: ViewerPanelId,
  activityId: number,
): ActivityViewerCollapsedAction {
  return {
    type: ActivityViewerActionsEnum.COLLAPSED,
    payload: {
      panelId,
      activityId,
    },
  };
}

/*
 * Union type.
 */

export type ActivityViewerActions = ActivityViewerExpandedAction | ActivityViewerCollapsedAction;
